import React from 'react';

const SpeedMeter = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="65"
    height="64"
    viewBox="0 0 65 64"
    fill="none"
    {...props}
  >
    <circle cx="32.5" cy="32" r="32" fill="#E6F1FE" />
    <path
      d="M32.9001 21V23.4"
      stroke="#0E3054"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.5002 32.4004H21.5002"
      stroke="#0E3054"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.9581 24.3418L38.9001 26.3998"
      stroke="#0E3054"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.9002 26.3998L24.8362 24.3418"
      stroke="#0E3054"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.9 40.8C46.598 38.436 47.3 35.538 47.3 32.4C47.3 24.438 40.856 17.988 32.9 18C24.932 17.994 18.482 24.438 18.5 32.4C18.494 35.538 19.196 38.436 20.9 40.8H44.9Z"
      stroke="#0E3054"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.84 26.454C37.322 24.936 35.216 23.994 32.9 24C28.25 24 24.488 27.756 24.5 32.4"
      stroke="#0E3054"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.3001 29.4004L34.6521 31.7764C34.1601 31.4164 33.5541 31.2004 32.9001 31.2004C32.0721 31.2004 31.3221 31.5364 30.7761 32.0764C30.2361 32.6164 29.9001 33.3724 29.9001 34.2004C29.9001 35.0284 30.2361 35.7844 30.7761 36.3244C31.3161 36.8644 32.0721 37.2004 32.9001 37.2004C33.7281 37.2004 34.4781 36.8644 35.0241 36.3244C35.5641 35.7784 35.9001 35.0284 35.9001 34.2004C35.9001 34.1044 35.8821 34.0144 35.8701 33.9244L41.3001 29.4004Z"
      stroke="#0E3054"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SpeedMeter;
